export const beneficiaryProfile = {
  relationship: '',
  name: {
    firstName: '',
    lastName: ''
  },
  dateOfBirth: {
    year: '',
    month: '',
    day: '',
  },
  identityNo: '',
  phoneNo: '',
  mail: '',
  address: {
    city: '',
    area: '',
    road: ''
  },
}

export const travelNoticeData = {
  hasOtherInsu: {
    value: false,
    desc: ''
  },
  isCheckCoverage: false,
  famiyYearIncome: '',
  economicSources: '',
  isNative: true,
  job: '',
  isOverSixMons: {
    value: false,
    desc: ''
  },
  isPolitician: {
    value: false,
    desc: ''
  },
  PremiumSources:
  {
    value: '',
    desc: ''
  },
  IsPolicyLoan:false
}